var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 256.14l-56.51 56.47-96.44-96.15a23.77 23.77 0 0 1-.18-33.61l.18-.18 22.59-22.51a23.94 23.94 0 0 1 33.85 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M313 182.57L290.21 160a23.94 23.94 0 0 0-33.85 0L103.47 312.61 143 352l.06.06a24 24 0 0 0 33.93-.16L313 216.36l.18-.17a23.78 23.78 0 0 0-.18-33.62z","className":"fa-primary","key":2})]);
}

AngleDown.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
